import React, {
  FC,
  useLayoutEffect,
  useEffect,
  useRef,
  useMemo
} from 'react';
import { Title } from '@npm-registry/eapteka-ui';
import clsx from 'clsx';
import { Installment } from '@front-office/app-installment';
import { useDispatch, useSelector } from 'react-redux';
import {
  installmentInformerClick,
  AppDispatch
} from '../../../store';
import {
  selectIsCartInstallmentAvailable,
  selectPreorderCount,
  selectTotalPrice
} from '../../../store/summary';
import { text } from '../../../text';
import { ProductsLists } from '../../blocks/ProductsLists';
import { ClearCartButton } from '../../elements/ClearCartButton';
import { Promocode } from '../../elements/Promocode';
import { Recipe } from '../../elements/Recipe';
import { Summary } from '../../blocks/Summary';
import { PreorderBanner } from '../../elements/Preorder';
import { CartPageProps } from './types';
import styles from './CartPage.scss';

export const CartPage: FC<CartPageProps> = ({
  predictCartCount
}) => {
  const dispatch: AppDispatch = useDispatch();
  const asideRef = useRef<HTMLDivElement | null>(null);
  const count: number = useSelector(selectPreorderCount);
  const totalPrice = useSelector(selectTotalPrice);
  const isCartInstallmentAvailable = useSelector(
    selectIsCartInstallmentAvailable
  );
  const rootClassNames = useMemo(
    () =>
      clsx([
        styles.root,
        { [styles.rootHasPreorder]: count > 0 }
      ]),
    [count]
  );
  const asideClassNames = useMemo(
    () =>
      clsx([
        styles.aside,
        { [styles.asideIsHost]: window._eaptekaIsHostMF }
      ]),
    []
  );

  useEffect(() => {
    document.addEventListener('BNPL:click', () => {
      dispatch(installmentInformerClick());
    });
  }, []); // eslint-disable-line

  useLayoutEffect(() => {
    document.dispatchEvent(
      new CustomEvent('appCartPageSummaryRerender', {
        detail: {
          asideContainer: asideRef.current
        }
      })
    );
  });

  return (
    <div className={rootClassNames}>
      <div className={styles.container}>
        <header className={styles.header}>
          <Title tag="h1" className={styles.title}>
            {text['cart.header']}
          </Title>
          <ClearCartButton className={styles.clear} />
        </header>
        <PreorderBanner className={styles.preorder} />
        <main className={styles.main}>
          <ProductsLists
            predictCartCount={predictCartCount}
          />
        </main>
        <aside className={asideClassNames} ref={asideRef}>
          <Summary />
          <Promocode />
          {isCartInstallmentAvailable && (
            <Installment
              cartSummary={totalPrice.value}
              page="cart"
            />
          )}
          <Recipe />
        </aside>
      </div>
    </div>
  );
};
